import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import {
  PagePaginationResponseDtoSchema,
  responseContract,
  type PagePaginationRequestDto,
} from '../../lib';

const ManagerFacilityDtoSchema = z.object({
  assignedAt: z.string(),
  assignedBy: z
    .object({
      id: z.number(),
      email: z.string(),
    })
    .nullable(),
  facilityId: z.number(),
  name: z.string(),
  managers: z.array(
    z.object({
      id: z.number(),
      email: z.string(),
    })
  ),
});

const GetFacilitiesByManagerResponseDtoSchema = PagePaginationResponseDtoSchema(
  ManagerFacilityDtoSchema
);

export type GetFacilitiesByManagerRequestDto = PagePaginationRequestDto<
  { managerId: string },
  'name' | 'assignedAt'
>;
export type GetFacilitiesByManagerResponseDto = z.infer<
  typeof GetFacilitiesByManagerResponseDtoSchema
>;
export type ManagerFacilityDto = z.infer<typeof ManagerFacilityDtoSchema>;

export const getFacilitiesByManager = (
  params: GetFacilitiesByManagerRequestDto,
  config?: AxiosRequestConfig<GetFacilitiesByManagerRequestDto>
) => {
  const { managerId, ...restParams } = params;

  return api
    .get(`/managers/${managerId}/facilities`, {
      params: restParams,
      ...config,
    })
    .then(responseContract(GetFacilitiesByManagerResponseDtoSchema));
};
